import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const isFloatedZeus = location.pathname === '/floatedzeus';
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="header-brand" onClick={() => setIsMenuOpen(false)}>
          <img
            src={`${process.env.PUBLIC_URL}${isFloatedZeus ? '/floatedzeus-favicon.png' : '/zclogo.png'}`}
            alt="Site Icon"
            className="header-icon"
          />
          <span className="header-name">{isFloatedZeus ? 'FloatedZeus' : 'Zach Cohen'}</span>
        </Link>
        <button className="menu-button" onClick={toggleMenu}>
          {isMenuOpen ? '✕' : '☰'}
        </button>
        <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          {/* Projects hidden for now
          <Link to="/projects" onClick={() => setIsMenuOpen(false)}>Projects</Link>
          */}
          <Link to="/about" onClick={() => setIsMenuOpen(false)}>About</Link>
          {/* FloatedZeus hidden for now
          <Link to="/floatedzeus" onClick={() => setIsMenuOpen(false)}>FloatedZeus</Link>
          */}
        </nav>
      </div>
    </header>
  );
};

export default Header;
